import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "verifiedSeal"
const VerifiedSealIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            d="m22 11.51-2.218-2.528.309-3.346-3.282-.745-1.718-2.891-3.091 1.327-3.09-1.327-1.72 2.89-3.28.737.308 3.346-2.218 2.536 2.218 2.527-.309 3.355 3.282.745 1.718 2.891 3.091-1.336 3.09 1.327 1.72-2.89 3.28-.746-.308-3.346zm-11.818 4.545-3.637-3.637 1.282-1.282 2.355 2.346 5.99-5.991 1.283 1.29z"
            fillRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default VerifiedSealIcon
